import React from 'react';
import Card from '@common/components/card';

type SettingsCardProps = {
  title: string;
  description: string;
  action?: React.ReactNode;
  content: React.ReactNode;
  footer?: React.ReactNode;
};

export const SettingsCard: React.FC<SettingsCardProps> = ({
  title,
  description,
  action,
  content,
  footer,
}) => (
  <Card>
    <Card.Header>
      <div className="tw-flex tw-flex-row tw-justify-between tw-gap-[6px] tw-items-center">
        <div className="tw-flex tw-flex-col tw-justify-between">
          <div className="tw-text-xl tw-font-semibold tw-font-inter tw-text-[#27272A]">
            {title}
          </div>
          <div className="tw-text-base tw-font-medium tw-font-inter tw-text-[#71717A]">
            {description}
          </div>
        </div>
        <div className="">
          {action}
        </div>
      </div>
    </Card.Header>
    <Card.Content className="tw-flex tw-flex-col tw-gap-5">
      {content}
    </Card.Content>
    {footer && (
      <Card.Footer
        className="tw-flex tw-flex-row tw-gap-1 !tw-px-4 !tw-pb-4 !tw-pt-0"
      >
        {footer}
      </Card.Footer>
    )}
  </Card>
);
